const Config = {
  network: {
    backendUrl: 'https://dev.cxhub.watch',
  }
}

export default Config
